import { createORM } from "pinia-orm";
import Audit from "./Audit.js";
import Mission from "./Mission.js";
import User from "./User.js";
import ActionPlan from "./ActionPlan.js";
import QuestionnaireSession from "./QuestionnaireSession.js";
import Question from "./Question.js";
import ActivityNature from "./ActivityNature.js";
import Domain from "./Domain.js";
import TaskResult from "./TaskResult.js";
import Document from "./Document.js";
import Agency from "./Agency.js";

// Create ORM instance and register models
export const orm = createORM({
  models: [
    Audit,
    Mission,
    User,
    ActionPlan,
    QuestionnaireSession,
    Question,
    ActivityNature,
    Domain,
    TaskResult,
    Document,
    Agency,
  ],
});

export {
  Audit,
  Mission,
  User,
  ActionPlan,
  QuestionnaireSession,
  Question,
  ActivityNature,
  Domain,
  TaskResult,
  Document,
  Agency,
};
